import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ModalProvider, Modal } from "./context/modal/Modal";
import configureStore from "./store";
import * as sessionActions from "./store/session";
import App from "./App";
import Cookies from "js-cookie";
import './style/responsive.css'

import "./output.css";
import { ActionModal } from "./context/actionModal/ActionModal";
// import './index.css'

const store = configureStore();

// Export the store so it can be used by the session timeout utility
export { store };

if (process.env.NODE_ENV !== "production") {
  window.store = store;
  window.sessionActions = sessionActions;
}

const csrfToken = Cookies.get("csrf_token");

if (csrfToken) {
  fetch("/api/csrf/restore", {
    method: "GET",
    headers: {
      "X-CSRFToken": csrfToken,
    },
  });
}

// Wrap the application with the Modal provider and render the Modal component
// after the App component so that all the Modal content will be layered as
// HTML elements on top of the all the other HTML elements:
function Root() {
  return (
    <ModalProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
          <Modal />
          <ActionModal/>
        </BrowserRouter>
      </Provider>
    </ModalProvider>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
